/** @format */

import { createGlobalStyle } from "styled-components";

export const GlobalStyles = createGlobalStyle`
    *, *::after, *::before {
        box-sizing: border-box;
    }
    body, nav ul, .fade, nav {
        background: ${({ theme }) => theme.body};
        color: ${({ theme }) => theme.textPrimary};
        transition: all 0.25s linear;
    }
    .dark {
        display: ${({ theme }) => theme.displayrev};
    }
    .white {
        display: ${({ theme }) => theme.display};
    }
    .btn, .btn a {
        color: ${({ theme }) => theme.body};
    }
    .btn-outline {
        background: ${({ theme }) => theme.body};
        color: ${({ theme }) => theme.textSecondary};
        border: 1px solid ${({ theme }) => theme.textSecondary};
    }
    .btn-outline:hover {
        color: ${({ theme }) => theme.body};
    }
    .bg-light {
        background: ${({ theme }) => theme.bodySecondary};
        color: ${({ theme }) => theme.body};
    }
    .handle__recommend, b {
        color: ${({ theme }) => theme.textSecondary};
        font-style: italic;
    }
    .background div {
        border: 0.5px solid ${({ theme }) => theme.backgLight};
    }
    @media screen and (min-width: 992px) {
        .fade {
            background: none;
            //display: none
        }
    }
`;
